<!-- bloquea la pantalla general -->
<block-ui ></block-ui>

<!-- barra que indica el progreso de un proceso -->
<bank-progress-bar></bank-progress-bar>

<!-- notificaciones toastr para las alrmas de precios -->
<toast-notification></toast-notification>

<!-- zona general donde se muestra el contenido -->
<router-outlet KeysBlock></router-outlet>